module.exports = {
    NOTIF: 'NOTIF'
}



// WEBPACK FOOTER //
// ./src/components/actions/constants/ActionConstants.js